// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"7694dcc4","295":"6d74c093","314":"f9a13df5","397":"7ad653ee","435":"be69fa87","466":"cf9856f1","727":"00981209","796":"9fc526db","847":"f1729021","889":"b3d04e75","890":"0420476f","920":"834c9944"}[chunkId] + ".chunk.js";
};